import { init, browserTracingIntegration, replayIntegration } from '@sentry/react';
import { gitRev, sentryDsn, sentryEnvironment } from './environments/environment';
import { isNil } from 'lodash-es';

if (!isNil(sentryDsn)) {
  init({
    dsn: sentryDsn ?? undefined,
    environment: sentryEnvironment,
    release: gitRev,
    attachStacktrace: true,
    tracesSampleRate: 0.1,
    integrations: [browserTracingIntegration(), replayIntegration()],
  });
}
